import React, { useState } from 'react';

export function HgFitment({ content }) {
  if (!content?.fitment_html) return null;
  return <section aria-label="Passend für – Herstellerangaben">
    <h3>Passend für</h3>
    <p style={{opacity:0.8}}>Fahrzeugzuordnung und Einschränkungen laut HG-Motorsport. Angaben wie „bei uns im Haus“ beziehen sich auf den Hersteller.</p>
    <div className="desc-content" style={{overflowX:'auto',maxWidth:'100%',lineHeight:1.7}}
      dangerouslySetInnerHTML={{__html:content.fitment_html}} />
  </section>;
}
function HgVideo({ video, index }) {
  const [playing,setPlaying] = useState(false);
  if (!/^[A-Za-z0-9_-]{11}$/.test(video.id || '')) return null;
  return <article style={{marginBottom:24}}>
    <h3>Herstellervideo {index + 1}</h3>
    <div style={{aspectRatio:'16 / 9',background:'#161616',borderRadius:12,overflow:'hidden',display:'grid',placeItems:'center'}}>
      {playing ? <iframe title={`HG-Motorsport Produktvideo ${index+1}`}
        src={`https://www.youtube-nocookie.com/embed/${video.id}`}
        style={{width:'100%',height:'100%',border:0}} allow="encrypted-media; picture-in-picture" allowFullScreen />
        : <div style={{padding:20,textAlign:'center',color:'#fff'}}>
          <p>Beim Laden wird eine Verbindung zu YouTube hergestellt.</p>
          <button type="button" onClick={()=>setPlaying(true)} style={{background:'#EC2229',color:'#fff',border:0,borderRadius:8,padding:'12px 20px',cursor:'pointer'}}>▶ Video laden</button>
        </div>}
    </div>
    <a href={`https://www.youtube.com/watch?v=${video.id}`} target="_blank" rel="noopener noreferrer">Auf YouTube ansehen ↗</a>
  </article>;
}
export function HgVideos({ content }) {
  return <section aria-label="Produktvideos">{(content?.videos || []).map((video,index)=><HgVideo key={video.id} video={video} index={index} />)}</section>;
}
